
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/initializing-products",
      function () {
        return require("private-next-pages/docs/link/initializing-products.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/initializing-products"])
      });
    }
  